/**
 * @generated SignedSource<<2a5ab2ac4759f2488391085907b3ed9b>>
 * @relayHash d3adfd96cf5547776151651b69eb76b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d237b13529b7cb66d204f6a282a19234e2da070840529442d51c9129eea88e0a

import type { ConcreteRequest, Query } from 'relay-runtime';
export type HelpObjectStoreArticleContentType = "FOLDER" | "PAGE" | "%future added value";
export type HelpObjectStoreArticleSearchExpandType = "ANCESTORS" | "VIEW_COUNT" | "%future added value";
export type HelpObjectStoreSupportSiteArticleSearchInput = {
  articleIds?: ReadonlyArray<string> | null | undefined;
  contentTypes?: ReadonlyArray<HelpObjectStoreArticleContentType> | null | undefined;
  expand?: ReadonlyArray<HelpObjectStoreArticleSearchExpandType> | null | undefined;
  orderBy?: string | null | undefined;
  parentId?: AGG$Long | null | undefined;
  query?: string | null | undefined;
  topLevelArticlesOnly?: boolean | null | undefined;
};
export type resolvedAndErrorContentQuery$variables = {
  cloudId: string;
  first?: number | null | undefined;
  helpCenterAri: string;
  input: HelpObjectStoreSupportSiteArticleSearchInput;
};
export type resolvedAndErrorContentQuery$data = {
  readonly helpObjectStore_searchArticlesForSupportSite: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly contentType?: HelpObjectStoreArticleContentType | null | undefined;
        readonly id?: string;
        readonly message?: string | null | undefined;
        readonly title?: string;
        readonly urlInfo?: {
          readonly shareUrl: string;
        };
      };
    }> | null | undefined;
  } | null | undefined;
};
export type resolvedAndErrorContentQuery = {
  response: resolvedAndErrorContentQuery$data;
  variables: resolvedAndErrorContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v4 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v5 = {
  "kind": "Variable",
  "name": "helpCenterAri",
  "variableName": "helpCenterAri"
},
v6 = {
  "kind": "Variable",
  "name": "input",
  "variableName": "input"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "contentType"
    },
    {
      "concreteType": "HelpObjectStoreArticleURLInfo",
      "kind": "LinkedField",
      "name": "urlInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "shareUrl"
        }
      ]
    }
  ],
  "type": "HelpObjectStoreSupportSiteArticleSearchResult"
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
},
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v11 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v12 = [
  (v4/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v5/*: any*/),
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "resolvedAndErrorContentQuery",
    "selections": [
      {
        "alias": "helpObjectStore_searchArticlesForSupportSite",
        "args": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
        "kind": "LinkedField",
        "name": "__ResolvedAndErrorContent__helpObjectStore_searchArticlesForSupportSite_connection",
        "plural": false,
        "selections": [
          {
            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ]
              },
              (v10/*: any*/)
            ]
          },
          (v11/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "resolvedAndErrorContentQuery",
    "selections": [
      {
        "args": (v12/*: any*/),
        "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
        "kind": "LinkedField",
        "name": "helpObjectStore_searchArticlesForSupportSite",
        "plural": false,
        "selections": [
          {
            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/)
                ]
              },
              (v10/*: any*/)
            ]
          },
          (v11/*: any*/)
        ]
      },
      {
        "args": (v12/*: any*/),
        "filters": [
          "cloudId",
          "helpCenterAri",
          "input"
        ],
        "handle": "connection",
        "key": "ResolvedAndErrorContent__helpObjectStore_searchArticlesForSupportSite",
        "kind": "LinkedHandle",
        "name": "helpObjectStore_searchArticlesForSupportSite"
      }
    ]
  },
  "params": {
    "id": "d237b13529b7cb66d204f6a282a19234e2da070840529442d51c9129eea88e0a",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": null,
          "direction": "forward",
          "path": [
            "helpObjectStore_searchArticlesForSupportSite"
          ]
        }
      ]
    },
    "name": "resolvedAndErrorContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8f52dcfd8c2f8d8ee3e0ac349b7693a1";

export default node;
